import produce from 'immer';

import {ProcedureFlowchart} from 'procedures/ProcedureDomainTypes';
import {BenchlingAction} from 'redux-stores/Action';

import {ProceduresActionType} from './proceduresActions';

export interface ProceduresState {
  flowchartsBeingEdited: Record<string, ProcedureFlowchart>;
}

export const PROCEDURES_INITIAL_STATE: ProceduresState = {
  flowchartsBeingEdited: {},
};

export default function reduceProcedures(
  state: ProceduresState = PROCEDURES_INITIAL_STATE,
  action: BenchlingAction
): ProceduresState {
  switch (action.type) {
    case ProceduresActionType.UPDATED_FLOWCHART:
      return produce(state, (draftState) => {
        draftState.flowchartsBeingEdited[action.procedureId] = action.flowchart;
      });

    case ProceduresActionType.RELEASED_FLOWCHART:
      return produce(state, (draftState) => {
        delete draftState.flowchartsBeingEdited[action.procedureId];
      });

    default:
      return state;
  }
}
